import TextDisplay from 'src/components/Review/TextDisplay';

export default function OwnersStatement({ info }) {
  return (
    <TextDisplay field="Owner's Statement of Circumstances and Request for Relief" value={info} />
  );
}
